import { render, staticRenderFns } from "./RightFourth.vue?vue&type=template&id=037aa53a&scoped=true"
import script from "./RightFourth.vue?vue&type=script&lang=js"
export * from "./RightFourth.vue?vue&type=script&lang=js"
import style0 from "./RightFourth.vue?vue&type=style&index=0&id=037aa53a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037aa53a",
  null
  
)

export default component.exports